import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import ProductStore from '../../../modulos/produtoEvento/containers/productStore/ProductStore';

class ProdutoEventoNavegacao extends React.Component {
  render() {
    return (      
      <Switch>
        <Route path="/" exact component={ProductStore} />
      </Switch>
    )
  }
}

export default ProdutoEventoNavegacao;